export const PASSAGE_FETCH_REQUEST = 'PASSAGE_FETCH_REQUEST';
export const PASSAGE_FETCH_SUCCESS = 'PASSAGE_FETCH_SUCCESS';
export const PASSAGE_FETCH_FAIL = 'PASSAGE_FETCH_FAIL';
